import script from "./TariffTime.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffTime.vue?vue&type=script&setup=true&lang=js"

import "./TariffTime.vue?vue&type=style&index=0&id=7ba58203&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba58203"]])

export default __exports__